import { InMemoryCache } from '@apollo/client'

import { sharedTypePolicies } from '@docpace/shared-graphql'

export const cache = new InMemoryCache({
    typePolicies: sharedTypePolicies
})
